module.exports = __webpack_public_path__ + "img/9788957983263.f8ee3b1c.jpg";